import TechnicalStatusFilter from "./technical-status-filter.vue";

export default TechnicalStatusFilter;



// WEBPACK FOOTER //
// ./src/components/_dashboard/technical-status/filter/index.js